'use client';

import { ReactNode } from 'react';

import * as Intersection from '@/components/Intersection';
import { cx } from '@/ui/cva';

export default function HeaderFlyout({ children }: { children: ReactNode }) {
    const isVisible = !Intersection.useIsIntersecting(['header', 'title']);

    return (
        <div
            className="pointer-events-none fixed inset-x-0 top-[76px] z-10 h-0 lg:top-[92px]"
            aria-hidden
        >
            <div
                className={cx(
                    'absolute inset-x-0 top-0 overflow-hidden',
                    isVisible && 'pointer-events-auto'
                )}
            >
                <div
                    className={cx(
                        'border-b border-b-gray-100 bg-white transition',
                        !isVisible && '-translate-y-full opacity-0'
                    )}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}
